<template>
  <div class="d-flex" style="min-height: 45vw;">
    <div class="content p-4 w-100">
      <div class="d-flex">
        <h4 class="card-title mt-0">
          {{ i18n.global.t('pages.dailyReports.title') }}
        </h4>
        <p class="ml-5 pb-1 mb-1 align-self-end operation-office-initial-announce"
          v-show="operationOfficeInitialMessage && beforeSearchParams == null">
          {{ i18n.global.t('pages.common.list.initialMessageTwoDays') }}
        </p>
      </div>
      <div v-if="false" class="mb-5 d-flex justify-end">
        <div class="btn-area d-flex">
          <div>
            <FileDownloadBtn
              :showable="showableButtonArea"
              btnClass="exec-btn mt-0 ml-1"
              :btnName="i18n.global.t('pages.dailyReports.csv.refuelExport')"
              :type="downloadType"
              :disabled="isSelected"
              :deliveryPlans="selectedDeliveryPlans"
            />
          </div>
          <v-btn class="exec-btn mt-0 ml-1" @click="activateModalState">
            {{ i18n.global.t('pages.dailyReports.csv.refuelImport') }}
          </v-btn>
        </div>
      </div>
      <div>
        <DailyReportList
          class="mb-2"
          :pageInfo="pageInfo"
          :searched="searched"
          :items="dailyReportList"
          :listLoading="listLoading"
          :isOperationOffice="isOperationOffice"
          :isDepartment="isDepartment"
          @select="handleSelectDeliveryPlanId"
          @changeItem="reloadDailyReportList"
          :showFlash="showFlash"
          :notReady="notReady"
          :createAuthority="createAuthority"
          :updateAuthority="updateAuthority"
          :createSpotAuthority="createSpotAuthority"
        />
        <PaginateWithCount
          class="justify-end"
          v-model="currentPage"
          :totalPage="totalPage"
          :itemsPerPage="dailyReportPerPage"
          :allElementsCount="allDailyReportCount"
          :showItemCount="true"
        />
        <hr />
      </div>
      <h4>
        {{ i18n.global.t('pages.dailyReports.outputConditions') }}
      </h4>
      <div>
        <DailyReportOutputLayout
          v-model="selectOutputOptions"
          :isItTenkoKeeper="isItTenkoKeeper"
          @changePageComposition="changePageComposition"
          @changeIsItTenkoReacquisition="changeIsItTenkoReacquisition"
          @changeReportLayout="changeReportLayout"
        />
        <div v-show="showableButtonArea">
          <ButtonArea
            :operationOfficeId="form.operationOffice?.id"
            :deliveryPlans="selectedDeliveryPlans"
            :options="selectOutputOptions"
            :showFlash="showFlash"
            :isItTenkoReacquisition="isItTenkoReacquisition"
            :pageComposition="pageComposition"
            :selectedReportLayout="selectedReportLayout"
            @openModal="openFailedStatusTripIdsModal"
          />
        </div>
      </div>
    </div>

    <DailyReportSearchForm
      :loading="listLoading"
      :isOperationOffice="isOperationOffice"
      :isSubManagementOffice="isSubManagementOffice"
      :isManagementOffice="isManagementOffice"
      :isDepartment="isDepartment"
      @formchange="handleChangeSearchForm"
      @search="searchDailyReportList"
      :defaultBackDays="defaultBackDays"
    />
    <FileUploadModal
      :modalState="modalState"
      :title="i18n.global.t('pages.dailyReports.csv.refuelImportTitle')"
      uploadBtnClass='exec-btn mt-0 ml-1'
      closeBtnClass='mt-0'
      :type="uploadType"
      @closeModal="inactivateModalState"
      :isDailyReport:="true"
      :notes="i18n.global.t('pages.dailyReports.csv.refuelImportMessage')"
    />
    <FailedTripIdsModal
      :state="failedTripListModalState"
      :modalDisplayData="modalDisplayData"
      :operationOfficeName="operationOfficeName"
      @closeModal="failedTripListModalState = false"
    />
  </div>
</template>

<script>
  import { MANAGEMENT_OFFICE_TYPE, SUB_MANAGEMENT_OFFICE_TYPE, OPERATION_OFFICE_TYPE, DEPARTMENT_OFFICE_TYPE } from "@/services/consts.ts"
  import DailyReportSearchForm from "@/components/DailyReportSearchForm"
  import DailyReportList from "@/components/DailyReportList"
  import DailyReportOutputLayout from "@/components/DailyReportOutputLayout"
  import ButtonArea from "@/components/DailyReportOutputButtonArea"
  import Api from "@/services/api/ApiServiceFabrick";
  import AuthorityCacheApi from "@/services/models/AuthorityCacheApi"
  import FileDownloadBtn from "@/components/DailyReportParts/DownloadButton"
  import FileUploadModal from "@/components/Files/UploadModal"
  import {ref} from 'vue'
  import { useAuth } from "@/services/user/Auth0UserProvider"
  import { formatDate } from "@/services/functions"
  import FailedTripIdsModal from "@/components/DailyReportParts/FailedTripIdsModal.vue"
  import PaginateWithCount from "@/components/PaginateWithCount.vue";
  import i18n from '@/lang/i18n';
  import { saveDataToSessionStorage, loadDataFromSessionStorage } from "@/services/functions/sessionStorage";
  import { DAILY_REPORT_PAGE_UNITS } from "@/services/consts";
  import { getSelfOffice } from "@/services/functions/operationOffice";

  export default {
    props: {
      showFlash: {
        type: Function
      },
      switchContentLoading: {
        type: Function
      }
    },
    data() {
      return {
        form: {},
        currentPage: 1,
        totalPage: 0,
        dailyReportList: [],
        selectedDeliveryPlans: [],
        selectOutputOptions: {},
        listLoading: false,
        searched: false,
        beforeSearchParams: null,
        lastRequest: null,
        isOperationOffice: false,
        isSubManagementOffice: false,
        isManagementOffice: false,
        isDepartment: false,
        operationOfficeInitialMessage: false,
        notReady: true,
        filterItems: {
          delivery_plan_ids: [],
        },
        downloadType: "App\\Services\\Csv\\Exports\\RefuelingAmountService",
        uploadType: "App\\Services\\Csv\\Imports\\RefuelingAmountService",
        modalState: false,
        isSelected: true,
        isItTenkoReacquisition: false,
        isItTenkoKeeper: false,
        operationOfficeName: "",
        failedTripListModalState: false,
        modalDisplayData: [],
        dailyReportPerPage: 50,
        allDailyReportCount: 0,
        defaultBackDays: 1,
        pageComposition: DAILY_REPORT_PAGE_UNITS[0],
        selectedReportLayout: null,
      }
    },
    computed: {
      borderWidth() {
        return '1000';
      }
    },
    setup() {
      document.title = i18n.global.t('pages.dailyReports.title')
      const showableButtonArea = ref(true)
      const createAuthority = ref(true)
      const updateAuthority = ref(true)
      const createSpotAuthority = ref(true)
      const setShowableButtonArea = async () => {
        const authorityList = await AuthorityCacheApi.getWithParse()
        showableButtonArea.value = !!authorityList["octlink.daily_report.output"]
        createAuthority.value = !!authorityList["octlink.daily_report.create"]
        updateAuthority.value = !!authorityList["octlink.daily_report.update"]
        createSpotAuthority.value = !!authorityList["octlink.spot.create"]
      }
      setShowableButtonArea()

      const { loginWithRedirect } = useAuth();

      return {
        showableButtonArea,
        updateAuthority,
        createAuthority,
        createSpotAuthority,
        loginWithRedirect,
        i18n
      }
    },
    mounted() {
      const savedIsItTenkoKeeper = loadDataFromSessionStorage('dailyReportIsItTenkoKeeper');
      if (savedIsItTenkoKeeper) {
        this.isItTenkoKeeper = savedIsItTenkoKeeper;
      }
      this.switchContentLoading(true)
      Api().getSelfAccount().then((data) => {
        this.isManagementOffice = data.login_organization_type == MANAGEMENT_OFFICE_TYPE
        this.isSubManagementOffice = data.login_organization_type == SUB_MANAGEMENT_OFFICE_TYPE
        this.isOperationOffice = data.login_organization_type == OPERATION_OFFICE_TYPE
        this.isDepartment = data.login_organization_type == DEPARTMENT_OFFICE_TYPE
        this.switchContentLoading(false)
        this.notReady = false
        const deliveryPlanId = this.$route.query.delivery_plan_id
        if (deliveryPlanId) {
          return this.getDailyReportsFilterByDeliveryPlanId(deliveryPlanId)
        }
        const savedResults = loadDataFromSessionStorage('dailyReportSearchResults');
        if (savedResults) {
          this.dailyReportList = savedResults.items;
          this.currentPage = savedResults.current_page;
          this.totalPage = savedResults.total_page;
          this.allDailyReportCount = savedResults.total;
          this.dailyReportPerPage = savedResults.per_page;
          this.searched = true;
          const savedFormValues = loadDataFromSessionStorage('dailyReportSearchForm');
        } else if (this.isOperationOffice || this.isDepartment) {
          return this.getInitialDailyReport()
        }
      })
    },
    watch: {
      currentPage: {
        handler() {
          this.getDailyReports(this.currentPage, false)
        }
      },
      isItTenkoKeeper: {
        handler(newVal) {
          saveDataToSessionStorage('dailyReportIsItTenkoKeeper', newVal);
        },
      },
    },
    methods: {
      async getInitialDailyReport() {
        this.listLoading = true
        let selfDepartment
        let selfOperationOffice
        if (this.isDepartment) {
          selfDepartment = await this.getDepartment()
        }
        selfOperationOffice = await this.getSelfOffice()
        const request = this.makeInitialParams(selfOperationOffice, selfDepartment)
        this.apiGetDailyReports(request)
      },
      async getDepartment() {
        let department
        await Api().autoCompleteDepartments().then((data) => {
          department = data
        })
        return department
      },
      async getSelfOffice() {
        const selfOffice = await getSelfOffice()
        this.operationOfficeName = selfOffice.operation_office_name
        this.isItTenkoKeeper = !!selfOffice.tenko_type
        return selfOffice
      },
      makeInitialParams(operationoffice, departments = []) {
        let page = 1
        let dateRange = [new Date(), new Date()]
        dateRange[0].setDate(dateRange[0].getDate() - this.defaultBackDays)
        const department = departments.length == 1 ? departments[0] : null

        const ret = {
          page: page,
          operation_office_id: operationoffice?.id,
          management_office_id: operationoffice?.management_officeable_id,
          management_officeable_type: operationoffice?.management_officeable_type,
          department_id: department?.id,
          daterange: this.convertDateTimeTodate(dateRange[0]) + " - " + this.convertDateTimeTodate(dateRange[1])
        }
        ret["delivery_date"] = 1
        return ret
      },
      handleChangeSearchForm(form) {
        this.form = form
      },
      handleSelectDeliveryPlanId(selectedDeliveryPlans) {
        this.selectedDeliveryPlans = selectedDeliveryPlans
        this.isSelected = false
        if (this.selectedDeliveryPlans.length == 0) {
          this.isSelected = true
        }
      },
      searchDailyReportList() {
        this.operationOfficeInitialMessage = false
        this.searched = true
        this.selectedDeliveryPlans = []
        this.getDailyReports()
      },
      reloadDailyReportList() {
        if (!this.lastRequest) {
          return this.searchDailyReportList()
        }
        this.listLoading = true
        this.isSelected = true
        this.selectedDeliveryPlans = []
        this.apiGetDailyReports({ ...this.lastRequest, page: this.currentPage })
      },
      getDailyReports(page = 1, updateOption = true) {
        this.listLoading = true
        this.isSelected = true
        let req
        if (updateOption || !this.beforeSearchParams) {
          req = this.makeSearchParams(page)
          this.getOperationOffice(this.form?.operationOffice?.id)
          this.beforeSearchParams = req
        } else {
          req = this.beforeSearchParams
          req.page = page
        }
        this.apiGetDailyReports(req)
      },
      apiGetDailyReports(req) {
        this.lastRequest = { ...req }
        Api().getDailyReports(req).then((data) => {
          this.dailyReportList = data.items
          this.currentPage = data.current_page
          this.totalPage = data.total_page
          this.listLoading = false
          this.operationOfficeInitialMessage = true
          this.allDailyReportCount = data.total
          this.dailyReportPerPage = data.per_page
          saveDataToSessionStorage('dailyReportSearchResults', data);
        }).catch((error) => {
          const res = error.response
          switch (res.status) {
            case 401:
              this.loginWithRedirect({ appState: { targetUrl: location.pathname } })
              break
            case 403:
              location.reload()
              break
            case 422:
              this.showFlash(i18n.global.t('pages.dailyReports.errorMessage.getList'), "error", false)
          }
          this.listLoading = false
        })
      },
      makeSearchParams(page){
        const ret = {
          page: page,
          operation_office_id: this.form?.operationOffice?.id,
          management_office_id: this.form?.managementOffice?.id,
          management_officeable_type: this.form?.managementOffice?.type,
          group_id: this.form?.group?.id,
          group_type: this.form?.group?.type,
          department_id: this.form?.department?.id,
          car_id: this.form?.vehicle?.id,
          driver_id: this.form?.driver?.driver_id,
          account_id: this.form?.driver?.id,
          daterange: this.convertDateTimeTodate(this.form?.dateRange[0]) + " - " + this.convertDateTimeTodate(this.form?.dateRange[1]),
        }
        const key = this.form.selectDateType == "returning" ? "return_date" : "delivery_date"
        ret[key] = 1
        return ret
      },
      async getOperationOffice(operationOfficeId) {
        let operationOffice
        await Api().getTenkoType(operationOfficeId).then((data) => {
          this.operationOfficeName = data.operation_office_name
          this.isItTenkoKeeper = !!data.tenko_type
          operationOffice = data
        })
        return operationOffice
      },
      convertDateTimeTodate(datetime) {
        if (!datetime) {
          return ''
        }
        return formatDate(datetime, '/')
      },
      inactivateModalState(isReacquire) {
        this.modalState = false;
        if (isReacquire && this.beforeSearchParams) {
          this.getDailyReports();
        }
      },
      activateModalState() {
        this.modalState = true;
      },
      changeIsItTenkoReacquisition(bool) {
        this.isItTenkoReacquisition = bool
      },
      openFailedStatusTripIdsModal(tripIdListAndStatus) {
        this.failedTripListModalState = true
        this.modalDisplayData = tripIdListAndStatus
      },
      changeReportLayout(reportLayoutKey) {
        this.selectedReportLayout = reportLayoutKey;
      },
      changePageComposition(pageComposition) {
        this.pageComposition = pageComposition;
      },
      getDailyReportsFilterByDeliveryPlanId(deliveryPlanId) {
        this.searched = true
        this.listLoading = true
        this.isSelected = true
        this.apiGetDailyReports({ delivery_plan_id: deliveryPlanId, page: 1 })
      }
    },
    components: {
      DailyReportSearchForm,
      DailyReportList,
      DailyReportOutputLayout,
      ButtonArea,
      FileDownloadBtn,
      FileUploadModal,
      FailedTripIdsModal,
      PaginateWithCount
    }
  }
</script>

<style scoped>
.content {
  min-width: 58vw;
}
.main-panel {
  height: initial !important;
  max-height: initial !important;
}
.ready-display {
  height: 100%;
  position: absolute;
  z-index: 1001;
  background-color: rgba(80,80,80,0.9);
  right: 0;
  left: 0;
}
.ready-display>label {
  font-weight: bold;
  color: white;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}
.exec-btn {
  background-color: rgb(21, 130, 156);
  color: white !important;
}
.reset-btn {
  background-color: rgb(245, 246, 247);
  color: rgb(21, 130, 156) !important;
  font-weight: bold;
}
.operation-office-initial-announce {
  font-size: 10px
}
</style>
